const urls = {
  lava: require('./lava.png').default,
  pikachu: require('./pikachu.jpg').default,
  plus: require('./plus.png').default,
  stone: require('./stone.jpg').default,
}

export default urls
